<template>
	<v-file-input
		:value="value"
		persistent-hint
		:label="label"
		:hint="hint"
		:accept="accept"
		:disabled="disabled"
		:multiple="multiple"
		:chips="true"
		:rules="rules"
		@change="onChange"
	></v-file-input>
</template>

<script>
	export default {
		props: {
			value: Array,
			label: String,
			hint: String,
			multiple: Boolean,
			required: Boolean,
			formats: String,
			maxSize: String,
			disabled: Boolean
		},
		data: () => ({

		}),
		created() {

		},
		computed: {
			accept() {
				if (!this.formats) return ''
				else return this.formats.split('|').map(f => '.' + f).join(', ')
			},
			rules() {
				const rules = []

				var rule

				if (this.required) {

					rule = v => {
						if (v !== null && v !== undefined && v.length > 0) return true
						else return 'Приложите файл'
					}

					rules.push(rule)
				}

				if (this.formats && this.formats.length) {
					let formats = this.formats.toLowerCase().split('|')

					rule = v => {
						for (let i in v) {
							if (v[i].name !== undefined) {
								let ext = v[i].name.split('.').pop().toLowerCase()
								if (formats.indexOf(ext) == -1) {
									return `Допустимые форматы: ${formats.join(', ')}`
								}
							}
						}
						return true
					}

					rules.push(rule)
				}

				if (+this.maxSize) {
					let max = +this.maxSize
					let mul = this.multiple

					rule = v => {
						for (let i in v) {
							if (v[i].size !== undefined) {
								let s = v[i].size / 1024 / 1024
								if (s > max) {
									return `Размер файла ${mul ? v[i].name : ''} составляет ${s.toFixed(2)} Mb и превышает максимальный - ${max} Mb`
								}
							}
						}
						return true
					}

					rules.push(rule)
				}

				return rules
			},
		},
		methods: {
			onChange (e) {
				this.$emit('input', e)
			},
		}
	}
</script>
